export default {
    allCategories: 'All Categories'
}